import React from 'react';
import { getSeasonStatsUrl } from '../data/utils/getSeasonStatsUrl';
import Loader from './Loader';
import { getLabel } from '../data/labels';
import OverlayWrapper from './OverlayWrapper';

export default function RankingsOverlay(props) {
    return (
        <OverlayWrapper id="xs-rankings-overlay">
            <div className="xs_rankingsOverlay z-50 absolute top-0 left-0 right-0 bottom-0 grid grid-rows-[48px_1fr] bg-cs1">
                <div className="xs_sectionNavbar z-20 border-b border-b-cs7 bg-cs1">
                    <div className="h-full grid grid-cols-12 items-center">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-x-lg font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className="col-start-3 col-end-13 font-medium text-lg text-cs-3">{getLabel('prematch.tournament.navbar.league_table')}</div>
                    </div>
                </div>
                <div className="relative">
                    <Loader />
                    <iframe title="xs-rankings-iframe" className="absolute top-0 left-0 right-0 bottom-0" width="100%" height="100%" src={getSeasonStatsUrl(props.classifica, props.sportId)} />
                </div>
            </div>
        </OverlayWrapper>
    );
}
